import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { UiState } from '../initial-states/stateTypes';

const initialState = initialStates.ui.normalState;

const reducer = produce((state: UiState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.USER_NEEDS_REGISTRATION:
      state.needsRegistration = action.payload;
      return state;
    case ActionType.USER_NEEDS_CFE_CREDENTIALS:
      state.needsCFECredentials = action.payload;
      return state;
    case ActionType.DONT_REMIND_USER_CFE_CFEDENTIALS:
      state.dontRemindUserCFECredentials = action.payload;
      return state;
    default:
      return state;
  }
}, initialState);

export default reducer;
